import styled from '@emotion/styled';
import { useGetCustomStyles, useGetStaticPages } from 'api/hooks';
//import { ReactComponent as DefaultBanner } from 'assets/defaultImages/GenericBanner.svg';
import DefaultBanner from 'assets/defaultImages/GenericBanner.png';
import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import { useLocation } from 'react-router-dom';
import { colors, hslToHSLA } from 'styles/colors';
import { Loading } from './Loading';

const GettingStartedContainer = styled.div`
  padding-bottom: 50px;
  padding: 0 95px;
`;

const BackgroundImageHolder = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 235px;
  overflow: hidden;
  z-index: -1;

  svg,
  img {
    width: 100%;
    min-height: 550px;
    transform: translate(0px, -15vw);
  }
`;
const BackgroundImageHolderScreen = styled.div`
  position: absolute;
  left: -95px;
  right: -95px;
  top: 0;
  height: 550px;

  background: ${hslToHSLA(colors.neptuneBlue, 0.6)};
`;

const GetStartedHeadings = styled.div`
  color: white;
  padding-bottom: 40px;
`;
const GetStartedTitle = styled.div`
  font-size: 48px;
  line-height: 58px;
  margin-top: 40px;

  svg * {
    fill: white;
  }
`;
const GetStartedDescription = styled.div`
  font-size: 24px;
  line-height: 34px;
  margin-top: 27px;
`;

const CustomMarkdownHolder = styled.div`
  padding: 80px 0;
`;

export const MarkdownDisplayPage = () => {
  let routerLoocation = useLocation();
  const { staticPages, staticPagesError } = useGetStaticPages();
  const { customStyles, customStylesError } = useGetCustomStyles();

  const pageOfInterest = staticPages?.find(staticPage => staticPage.path === routerLoocation.pathname);

  if (!pageOfInterest) {
    return <Loading center={true} />;
  }

  return (
    <GettingStartedContainer>
      <BackgroundImageHolder>
        <img src={customStyles?.bannerUrl || DefaultBanner} alt={''} />
        <BackgroundImageHolderScreen />
      </BackgroundImageHolder>

      <GetStartedHeadings>
        <GetStartedTitle>{pageOfInterest?.navigationLinkName}</GetStartedTitle>
        <GetStartedDescription>{pageOfInterest?.description}</GetStartedDescription>
      </GetStartedHeadings>

      {!!pageOfInterest?.content?.inlineString && (
        <CustomMarkdownHolder>
          <ReactMarkdown source={pageOfInterest.content.inlineString} />
        </CustomMarkdownHolder>
      )}
    </GettingStartedContainer>
  );
};
